
if(!__webpack_require__.federation){
    __webpack_require__.federation = {
        
chunkMatcher: function(chunkId) {
    return !/^(651|720|990)$/.test(chunkId);
},
rootOutputDir: "../",

    };
}
